<template>
<v-container grid-list-md>
  <bread-crump-partial header="Impressum"></bread-crump-partial>
    <h3 class="mb-2">Angaben gemäß § 5 Telemediengestz (TMG)</h3>
  <v-layout row wrap>
      <v-flex xs6 v-for="(legal,index) in itemsLegal" :key="index">
        <v-card>
          <v-card-title>
          {{legal.title}}
          </v-card-title>
          <v-card-text v-for="(para,index) in legal.paragraph" :key="index" v-html="para">
          </v-card-text>
        </v-card>
      </v-flex>
  </v-layout>
  <v-spacer class="mt-5"></v-spacer>
<h3 class="mb-2">Rechtliche Hinweise:</h3>
    <v-layout row wrap>
    <v-flex xs12 sm12 md12 v-for="(item,index) in items" :key="index">
      <v-card>
        <v-card-title>
          <!-- {{item.title}} -->
        </v-card-title>
        <v-card-text v-for="(para,index) in item.paragraph" :key="index" v-html="para">
        </v-card-text>
      </v-card>

    </v-flex>
  </v-layout>

</v-container>
</template>

<script>
  import BreadCrumpPartial from './partials/BreadCrumpPartial'
  import ContactWidget from './widgets/ContactWidget'

  export default {
    name: 'LegalPage',
    components: {
      BreadCrumpPartial,
      ContactWidget
    },
    data() {
      return {
        itemsLegal: [
          {
          title: 'Firma:',
          paragraph: [
            '<b>Smolin BudgetPlan GmbH</b><br />Lichterfelder Ring 208<br />12209 Berlin<br />'
            ]
          },
          {
            title: 'Gesetzlicher Vertreter:',
            paragraph : [
              'Herr Dr. Roland Smolin</br></br></br>'
            ]
          },
          {
            title: 'Handelsregister:',
            paragraph : [
              'Amstgericht Charlottenburg in Berlin, HRB 155536'
            ]
          },
          {
            title: 'UStIdNr gemäß §27 a Umsatzsteuergesetz:',
            paragraph: [
              'DE 292 833 311'
            ]
          },
           {
            title: 'Kontakt:',
            paragraph : [
              ' <table><tr><td><p>Telefon:</p></td><td><p>+49(0)30 756 523 31</p></td></tr><tr><td><p>Telefax:</p></td><td><p>+49(0)30 756 523 32</p></td></tr><tr><td><p>E-Mail:</p></td><td><p>info@smolin-budgetplan.com</p></td><tr><td><p>Internet:</p></td><td><p>www.smolin-budgetplan.com</p></td></tr></table>'
            ]
          },
          {
            title: 'Quellenangaben für die verwendeten Bilder:',
            paragraph: ['<a rel="nofollow" href="http://de.fotolia.com/id/49058708">&copy; Coloures-Pic - Fotolia.com</a><br /><a rel="nofollow" href="http://de.fotolia.com/id/50990348">&copy; alphaspirit - Fotolia.com</a><br /><a rel="nofollow" href="http://de.fotolia.com/id/48664923">&copy; alphaspirit - Fotolia.com</a><br />']
          }
        ],
        items: [{
          title: 'Rechtliche Hinweise',
          paragraph: [
            ' <h4>Haftung für Inhalte</h4>Als Diensteanbieter sind wir gemäß § 7 Abs.1 TMG für eigene Inhalte auf diesen Seiten nach den allgemeinen Gesetzen verantwortlich. Nach §§ 8 bis 10 TMG sind wir als Diensteanbieter jedoch nicht verpflichtet, übermittelte oder gespeicherte fremde Informationen zu überwachen oder nach Umständen zu forschen, die auf eine rechtswidrige Tätigkeit hinweisen. Verpflichtungen zur Entfernung oder Sperrung der Nutzung von Informationen nach den allgemeinen Gesetzen bleiben hiervon unberührt. Eine diesbezügliche Haftung ist jedoch erst ab dem Zeitpunkt der Kenntnis einer konkreten Rechtsverletzung möglich. Bei Bekanntwerden von entsprechenden Rechtsverletzungen werden wir diese Inhalte umgehend entfernen.',
            '<h4>Haftung für Links</h4>Unser Angebot enthält Links zu externen Webseiten Dritter, auf deren Inhalte wir keinen Einfluss haben. Deshalb können wir für diese fremden Inhalte auch keine Gewähr übernehmen. Für die Inhalte der verlinkten Seiten ist stets der jeweilige Anbieter oder Betreiber der Seiten verantwortlich. Die verlinkten Seiten wurden zum Zeitpunkt der Verlinkung auf mögliche Rechtsverstöße überprüft. Rechtswidrige Inhalte waren zum Zeitpunkt der Verlinkung nicht erkennbar. Eine permanente inhaltliche Kontrolle der verlinkten Seiten ist jedoch ohne konkrete Anhaltspunkte einer Rechtsverletzung nicht zumutbar. Bei Bekanntwerden von Rechtsverletzungen werden wir derartige Links umgehend entfernen.',
            '<h4>Urheberrecht</h4>Die durch die Seitenbetreiber erstellten Inhalte und Werke auf diesen Seiten unterliegen dem deutschen Urheberrecht. Die Vervielfältigung, Bearbeitung, Verbreitung und jede Art der Verwertung außerhalb der Grenzen des Urheberrechtes bedürfen der schriftlichen Zustimmung des jeweiligen Autors bzw. Erstellers. Downloads und Kopien dieser Seite sind nur für den privaten, nicht kommerziellen Gebrauch gestattet. Soweit die Inhalte auf dieser Seite nicht vom Betreiber erstellt wurden, werden die Urheberrechte Dritter beachtet. Insbesondere werden Inhalte Dritter als solche gekennzeichnet. Sollten Sie trotzdem auf eine Urheberrechtsverletzung aufmerksam werden, bitten wir um einen entsprechenden Hinweis. Bei Bekanntwerden von Rechtsverletzungen werden wir derartige Inhalte umgehend entfernen.',
            '<i>Quellen: Disclaimer von eRecht24, dem Portal zum Internetrecht von Rechtsanwalt Sören Siebert</i>'
          ]
        }]
      }
    }
  }
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/LegalPage.vue